import type {
  ConnectingEvent,
  EndEvent,
  IceCandidateEvent,
  IncomingEvent,
  Info,
  OutgoingEvent,
  PeerConnectionEvent,
  ReInviteEvent,
  SDPEvent,
  TerminateOptions,
} from 'jssip/lib/RTCSession';
import type { IncomingRequest } from 'jssip/lib/SIPMessage';
import type { URI } from 'jssip/lib/URI';
import { Subject } from 'rxjs';

import type {
  SipInfoMessage,
  SipSessionAcceptedEvent,
  SipMessageEvent,
} from 'features/sip/interfaces/';

export class SipSessionEventBus {
  public static readonly accepted$ = new Subject<SipSessionAcceptedEvent>();
  public static readonly failed$ = new Subject<EndEvent>();
  public static readonly getUserMediaFailed$ = new Subject<void>();
  public static readonly ended$ = new Subject<EndEvent>();
  public static readonly reInvite$ = new Subject<ReInviteEvent>();
  public static readonly connecting$ = new Subject<ConnectingEvent>();
  public static readonly progress$ = new Subject<
    OutgoingEvent | IncomingEvent
  >();
  public static readonly sdp$ = new Subject<SDPEvent>();
  public static readonly icecandidate$ = new Subject<IceCandidateEvent>();
  public static readonly incomingDtmf$ = new Subject<IncomingRequest>();
  public static readonly registerOnSipServer$ = new Subject<void>();
  public static readonly registerSuccess$ = new Subject<void>();
  public static readonly registerFailed$ = new Subject<void>();

  // Actions
  public static readonly terminate$ = new Subject<TerminateOptions | void>();
  public static readonly refer$ = new Subject<string | URI>();
  public static readonly peerConnection$ = new Subject<PeerConnectionEvent>();
  public static readonly updateCall$ = new Subject<OutgoingEvent>();
  public static readonly endCall$ = new Subject<void>();

  // SIP INFO messages
  public static readonly incomingInfo$ = new Subject<Info>();
  public static readonly outgoingInfo$ = new Subject<SipInfoMessage>();
  // SIP MESSAGE events
  public static readonly outgoingMessage$ = new Subject<SipMessageEvent>();
}
